// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mvcW","questions":"styles_questions__1_SR4","footer":"styles_footer__360-z"};